import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';
import EditAgentProfile from "./EditAgentProfile";

const ViewAgentProfile = ({uid,userLoggedInRoles,userDetails }) => {

    const [toggles, setToggles] = useState({
        AgentMainDetails: true,
        AgentJobTitle: true,
        AgentQnA: true,
        AgentBio: true,
        educationToggle: true,
        contactInfo: true,
        socialMediaToggle: true,
        AgentContractToggle: true,
        AthleteRepToggle: true
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

 
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);
    const[userAgentAssets,setUserAgentAssets] = useState({});
    const[userCommonAssets,setUserCommonAssets] = useState({});
    const[userAgentEditAssets,setUserAgentEditAssets] = useState({});
    const[userSocialMediaAssets,setUserSocialMediaAssets] = useState({});
    const [sportList, setSportList] = useState('');
    const [allAthletes, setAthleteList] = useState([]);
    const [assignedAthletes, setAssignedAthleteList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');


const sections = [
  {
    key: "field_agent_title",
    keyToggle: "AgentJobTitle",
    title: "Job Title",
    emptyText: "No job title set."
  },
  {
    key: "field_q_a",
    keyToggle: "AgentQnA",
    title: "Q&A",
    emptyText: "No Q&A content.",
    customClass: "qna-style", //  special styling
    customClass2: ""
  },
  {
    key: "field_agent_biography",
    keyToggle: "AgentBio",
    title: "Biography",
    emptyText: "No biography content.",
    customClass: "bio-style" //  special styling
  },
  {
    key: "field_education",
    keyToggle: "educationToggle",
    title: "Education",
    emptyText: "No education info.",
    customClass: "notes-style" //  special styling
  },
  {
    key: "field_how_to_contact_client",
    keyToggle: "contactInfo",
    title: "How to Contact",
    emptyText: "No contact info.",
    customClass: "notes-style" //  special styling
  }
];

const rightSectionFields = [
    { label: "Agent ID#", key: "field_agent_id", style: { fontSize: "16px" } },
    { label: "Slug", key: "field_agent_slug" },
    { label: "Expiration", key: "field_agent_expiration_date" },
    { label: "Agent Last Date of Accept", key: "field_last_date_accept" },
    { label: "Region", key: "field_agent_region" },
    {label: "Agent Sort Order", key: "field_agent_sort_order"},
    { label: "Show on Frontend", key: "field_show_on_frontend_agent" },
    { label: "Agent Featured", key: "field_agent_featured" }
];

    const [activeView, setActiveView] = useState("view");

    const showView = () => {
        const newView = activeView === "view" ? "edit_agent" : "agent";
        setActiveView(newView);

        navigate(`/user/${uid}/${newView}`);
    };

  const location = useLocation();

    useEffect(() => {
    if (location.pathname.includes("/edit_agent")) {
        setActiveView("edit");
    } else {
        setActiveView("view");
    }
    }, [location.pathname]);

const successAgentEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

        useEffect(() => {
          if (successAgentEditMessage) {
            setSuccessEditMessage(successAgentEditMessage);
            getagentdetails();
            getassignedathletelist();
            window.history.replaceState({}, '');
          }
        }, [successEditMessage, location.state]);

let parsedSportList = [];

try {
  parsedSportList = Array.isArray(sportList)
    ? sportList
    : JSON.parse(sportList);
} catch {
  parsedSportList = [];
}

const sportMap = Object.fromEntries(
  parsedSportList.map(s => [s.key, s.value])
);

const transformData = (dataArray) => {
  return dataArray.reduce((acc, item) => {
    acc[item.key] = item.full_value ?? item.value;
    return acc;
  }, {});
};

// const backEndData = transformData(userAgentAssets);

const commonBackEndData = userCommonAssets;

const mergedData = {
  ...commonBackEndData,
  ...userAgentAssets, 
};

// const backEndData = {
//   agentId: "3439099",
//   currentAgentId: null,
//   slug: "anastasia",
//   expiration: "Sep 8, 2022",
//   lastAcceptDate: null,
//   status: "Inactive",
//   showOnFrontend: "No"
// };
// const sportField = userAgentAssets?.find(
//   (item) => item.key === "field_agent_sports"
// );

// const sportlist = sportField?.value || [];


// const agentCertification = userAgentAssets?.find(
//   (item) => item.key === "field_agent_certifications"
// );

// const agentcertlist = agentCertification?.value || [];


// const backendData = {
//     jobTitle: "Senior Software Engineer",
//     qna: `
//         <p><strong>Q:</strong> What do you specialize in?</p>
//         <p><strong>A:</strong> Frontend development with React and performance optimization.</p>
//     `,
//     bio: `
//         <p>I have over 8 years of experience building scalable web applications.</p>
//         <p>I enjoy solving complex UI problems and improving user experience.</p>
//     `,
//     // jobTitle: "",
//     // qna: null,
//     // bio: ""
// };

    async function getsportslist() {
        try {
        const response = await fetch(
            app_url+'smwwagency/agentsports',
            {
                method: "GET",

                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data) {
        
            setSportList(responsedata.data);
            
        } 
        } catch (err) {
        
        }
        
    }

    async function getathletelist() {
        try {
            const response = await fetch(
                app_url+'report/getsalespersonactivity',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAthleteList(responsedata.data.result);
            
            } 
        } catch (err) {
            
        }
        
    }
    async function getassignedathletelist() {
        try {
            const response = await fetch(
            app_url+'smwwagency/getassignedathletelist?uid='+uid,
                {
                    method: "GET",

                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAssignedAthleteList(responsedata.data.result);
            
            } 
        } catch (err) {
            
        }
    }
    async function getagentdetails() { 
    
    if(uid!='') {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getagentdetails?uid='+uid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      //uid = responsedata.data.user.drupal_uid;
        setUserAgentAssets(responsedata.data.user_view_agent_assets);
        setUserSocialMediaAssets(responsedata.data.user_social_media_assets);
        setUserAgentEditAssets(responsedata.data.user_agent_assets);
        setUserCommonAssets(responsedata.data.user_common_assets);
    }
    }  catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }
  }

    useEffect(() => {
        if (!Array.isArray(userAgentEditAssets)) return;

        const contractItem = userAgentEditAssets.find(
            item => item.key === "field_agent_contract"
        );

        setAgentUploadedFiles(contractItem?.full_value || []);
    }, [userAgentEditAssets]);

    useEffect(() => {
    // const processData = () => {
    //     if (!Array.isArray(userAgentEditAssets)) return;
    //     if (userAgentEditAssets.length > 0) {
    //     userAgentEditAssets.forEach(item => {
    //         if (item['key'] === 'field_agent_contract') {
    //         setAgentUploadedFiles(item['full_value']);
    //         } 
    //     });
    //     }
    // };
    const promises = [
        getsportslist(),
        getathletelist(),
        getassignedathletelist(),
        getagentdetails()
    ];

    // processData(); // Sync processing
    //console.log(agentuploadFiles.length + "haiiii");

    Promise.all(promises)
        .then(() => {
        setIsLoading(false);
        })
        .catch(error => {
        console.error(error);
        // Handle error
        });
    }, []);

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png'; // fallback icon
        }
    };


// const fieldAgentCertifications = userAgentEditAssets.find(item => item.key === 'field_agent_certifications');

// if (fieldAgentCertifications) {
//   const { value, full_value, label } = fieldAgentCertifications;
//   return (
//     <div>
//       <h3>{label}</h3>
//       <p><strong>Value:</strong> {value.join(', ')}</p>
//       <p><strong>Full Value:</strong> {full_value}</p>
//     </div>
//   );
// } else {
//   return <p>No certifications available.</p>;
// }

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                <> 
                {activeView === "view" ? (
                <div>
                            <div className='viewtab-top-section'>

                                {successEditMessage && (
                                <div className="set-message-done" style={{marginBottom: "5px"}}>
                                    <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>&nbsp;
                                    {/* {successEditMessage} */}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: successEditMessage }}
                                    />
                                </div>
                                )}
                                <div>
                                    <div className="edit-agent-prof-editbtn">
                                        <button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button>
                                    </div>
                                    <div 
                                    className={`view-user-profile-section-header agent-section-header ${toggles["AgentMainDetails"] ? "open" : ""}`}
                                    style={{border: "0px", outline: "1px solid #bbb"}}
                                    >
                                        <div class="app-aspect-content" onClick={() => handleToggle("AgentMainDetails")}>
                                            <div class="aspect-info">
                                                <span class="view-user-profile-section-heading"><strong>Agent Profile</strong></span>
                                            </div>
                                        </div>
                                        {toggles.AgentMainDetails && (
                                            <div class="view-user-profile-section-body-container">
                                                <div class="view-user-profile-section-container user-profile-summary-table user-profile-details user-contact-info">

                                                    <div className="edit-agent-prof-details" 
                                                    style={(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))
                                                        ? {} : { justifyContent: "flex-start" }}
                                                    >
                                                        <div style={{flexShrink: "0"}}>
                                                            <div class="edit-agent-image">
                                                                {userAgentAssets.field_agent_photo ? (  
                                                                    <><img  src={userAgentAssets.field_agent_photo} width="100px" height="100px" alt = "user"/></>
                                                                ):(
                                                                    <div className="edit-agent-img-placeholder">No Photo<br />Uploaded</div>
                                                                )}
                                                            </div>
                                                            <div className="agent-img-desc">100–1000px · png/jpg/gif</div>
                                                        </div>
                                                
                                                        <div class="agent-name-loc" style={{marginBottom:'2%', minWidth: "200px", maxWidth: "495px"}}>
                                                            <div class="user-name" style={{color:"#333333"}} >{userDetails.first_name} {userDetails.last_name}</div>
                                                            <div class="user-loc" style={{marginBottom:"15px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
                                                            {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</div>
                                                        
                                                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && <>
                                                            <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Agent Sports</div>
                                                                <span
                                                                className="profile-applied-course-tag-row"
                                                                style={{ padding: "0px", marginBottom: "15px" }}
                                                                >
                                                                {Array.isArray(userAgentAssets.field_agent_sports) &&
                                                                    userAgentAssets.field_agent_sports.length > 0 ? (
                                                                        userAgentAssets.field_agent_sports.map((item, index) => (
                                                                            <span key={index} className="profile-applied-course-tags">
                                                                            {item}
                                                                            </span>
                                                                        ))
                                                                    ) : (
                                                                    <span
                                                                        className="profile-applied-course-tags"
                                                                        style={{ color: "#999", fontStyle: "italic" }}
                                                                    >
                                                                        None selected
                                                                    </span>
                                                                )}
                                                                </span>
                                                                                                                            
                                                            <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Agent Certifications</div>
                                                            <span
                                                            className="profile-applied-course-tag-row"
                                                            style={{ padding: "0px", marginBottom: "15px" }}
                                                            >
                                                            {Array.isArray(userAgentAssets.field_agent_certifications) &&
                                                                userAgentAssets.field_agent_certifications.length > 0 ? (
                                                                    userAgentAssets.field_agent_certifications.map((item, index) => (
                                                                        <span key={index} className="profile-applied-course-tags">
                                                                        {item}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                <span
                                                                     className="profile-applied-course-tags"
                                                                    style={{ color: "#999", fontStyle: "italic" }}
                                                                 >
                                                                    None selected
                                                                </span>
                                                            )}
                                                            </span>

                                                            {/* <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                            {userAgentAssets.field_agent_certifications && Array.isArray(JSON.parse(userAgentAssets.field_agent_certifications)) && JSON.parse(userAgentAssets.field_agent_certifications).length > 0 ? (
                                                                JSON.parse(userAgentAssets.field_agent_certifications).map((item, index) => (
                                                                    <span key={index} className="profile-applied-course-tags">
                                                                        {item}
                                                                    </span>
                                                                ))
                                                            ) : (
                                                                <span className="profile-applied-course-tags" style={{ color: "#999", fontStyle: "italic" }}>
                                                                    None selected
                                                                </span>
                                                            )}</span> */}

                                                            {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && <>
                                                            <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Special Certifications</div>
                                                                {/* <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                {userAgentAssets.field_special_certifications && Array.isArray(JSON.parse(userAgentAssets.field_special_certifications)) && JSON.parse(userAgentAssets.field_special_certifications).length > 0 ? (
                                                                    JSON.parse(userAgentAssets.field_special_certifications).map((item, index) => (
                                                                        <span key={index} className="profile-applied-course-tags">
                                                                            {item}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                    <span className="profile-applied-course-tags" style={{ color: "#999", fontStyle: "italic" }}>
                                                                        None selected
                                                                    </span>
                                                                )}</span> */}
                                                                <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                {Array.isArray(userAgentAssets.field_special_certifications) &&
                                                                    userAgentAssets.field_special_certifications.length > 0 ? (
                                                                        userAgentAssets.field_special_certifications.map((item, index) => (
                                                                            <span key={index} className="profile-applied-course-tags">
                                                                            {item}
                                                                            </span>
                                                                        ))
                                                                    ) : (
                                                                    <span
                                                                        className="profile-applied-course-tags"
                                                                        style={{ color: "#999", fontStyle: "italic" }}
                                                                    >
                                                                        None selected
                                                                    </span>
                                                                )}</span>
                                                            </>}
                                                            </>}

                                                        </div>
                                                    
                                                        {/* <div className='agent-profile-right'>
                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Agent ID#</div>
                                                                <div className="agent-profile-right-content-value" style={{fontSize: "16px"}}>3439099</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Current Agent ID</div>
                                                                <div className="agent-profile-right-content-value">-</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Slug</div>
                                                                <div className="agent-profile-right-content-value">anastasia</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Expiration</div>
                                                                <div className="agent-profile-right-content-value">Sep 8, 2022</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Agent Last Date of Accept</div>
                                                                <div className="agent-profile-right-content-value">-</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Inactive Agent Advisor</div>
                                                                <div className="agent-profile-right-content-value">Inactive</div>
                                                            </div>

                                                            <div className="agent-profile-right-content">
                                                                <div className="agent-profile-right-content-label">Show on Frontend</div>
                                                                <div className="agent-profile-right-content-value">No</div>
                                                            </div>
                                                        </div> */}
{(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
<div className="agent-profile-right">
    {rightSectionFields.map((item) => {
        const value = userAgentAssets?.[item.key];

        let displayValue = value;

        if (item.key === "field_show_on_frontend_agent" || item.key === "field_agent_featured") {
            displayValue = value === 1 ? "Yes" : "No";
        }

        return (
            <div className="agent-profile-right-content" key={item.key}>
                <div className="agent-profile-right-content-label">
                    {item.label}
                </div>

                <div
                    className="agent-profile-right-content-value"
                    style={item.style || {}}
                >
                    {displayValue ?? "-"}
                </div>
            </div>
        );
    })}
</div>}

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                </div>
                            </div>

{/* <div className={`view-user-profile-section-header ${toggles["AgentJobTitle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AgentJobTitle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Job Title</strong></span>
        </div>
    </div>
    {toggles.AgentJobTitle && (
        <div class="view-user-profile-section-body-container">
            <div class="opinion-header profile_summary view-agent-profile-section-content">
                <div className="agent-richtext-placeholder empty">No job title set.</div>
            </div>
        </div>
    )}
</div> */}


{sections.map((section) => {
//   const content = backEndData?.[section.key];
const content = mergedData?.[section.key];

  return (
    <div
      key={section.keyToggle}
      className={`view-user-profile-section-header ${
        toggles[section.keyToggle] ? "open" : ""
      }`}
    >
      <div
        className="app-aspect-content"
        onClick={() => handleToggle(section.keyToggle)}
      >
        <div className="aspect-info">
          <span className="view-user-profile-section-heading">
            <strong>{section.title}</strong>
          </span>
        </div>
      </div>

      {toggles[section.keyToggle] && (
        <div className="view-user-profile-section-body-container">
          <div
            className={`opinion-header profile_summary view-agent-profile-section-content ${
              section.customClass || ""
            }`}
          >
            {content ? (
              <div
                // className="agent-richtext-placeholder"
                className={`agent-richtext-placeholder ${section.customClass2 || ""}`}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              <div className="agent-richtext-placeholder empty">
                {section.emptyText}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
})}

<div className={`view-user-profile-section-header ${toggles["socialMediaToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("socialMediaToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Social Media</strong></span>
        </div>
    </div>
    {toggles.socialMediaToggle && (
    <div className="view-user-profile-section-body-container">
        {userSocialMediaAssets && Object.keys(userSocialMediaAssets).some(key => userSocialMediaAssets[key]) ? (
        <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
            <div className="opinion-header profile_summary view-user-profile-section-content">
            <table className="user-profile-summary-table">
                <tbody>
                {[
                    ['field_instagram_url', 'Instagram URL'],
                    ['field_instagram_handle', 'Instagram Handle'],
                    ['field_facebook_url', 'Facebook URL'],
                    ['field_facebook_handle', 'Facebook Handle'],
                    ['field_twitter_url', 'Twitter URL'],
                    ['field_user_youtube_url', 'YouTube URL'],
                    ['field_linkedin_url', 'LinkedIn URL'],
                    ['field_linkedin_handle', 'LinkedIn Handle'],
                ].map(([key, label]) => {
                    const value = userSocialMediaAssets[key];
                    // Skip empty values
                    if (!value) return null;
                    return (
                    <tr key={key}>
                        <td className="user-profile-summary-row" valign="top">
                        <span className="user-profile-label">
                            {label}:&nbsp;
                        </span>
                        </td>
                        <td className="user-profile-summary-row" valign="top">
                        <span className="user-profile-value">
                            {value || "-"}
                        </span>
                        </td>
                    </tr>
                    );
                })}
                </tbody>
            </table>
            </div>
        </div>
        ) : (
        <div className="opinion-header profile_summary view-agent-profile-section-content">
            <div className="agent-richtext-placeholder empty">
            No social media content.
            </div>
        </div>
        )}
    </div>
    )}
</div>

{(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && <>
<div className={`view-user-profile-section-header ${toggles["AgentContractToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AgentContractToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Agent Contract</strong></span>
        </div>
    </div>
    {toggles.AgentContractToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="opinion-header profile_summary view-agent-profile-section-content">
                {Array.isArray(agentuploadFiles) &&
                agentuploadFiles.length > 0 ? (
                <div className="agent-richtext-placeholder" style={{ border: "0" }}>
                    <ul>
                    {agentuploadFiles.map((file, index) => (
                        <li key={index}>
                            <img
                                src={getFileIcon(file.name)}
                                alt="file icon"
                            />&nbsp;
                            <a href={file.url} target="_blank" rel="noopener noreferrer">
                                {file.name}
                            </a>
                        </li>
                    ))}
                    </ul>
                </div>
                ) : (
                <div
                    className="agent-richtext-placeholder empty"
                    style={{ border: "0" }}
                >
                    No contract files uploaded. Allowed: txt, png, jpg, jpeg, pdf, docx (max 128 MB)
                </div>
                )}
            </div>
        </div>
    )}
</div>

<div className={`view-user-profile-section-header ${toggles["AthleteRepToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AthleteRepToggle")}>
        <div class="aspect-info">
            {/* <span class="view-user-profile-section-heading"><strong>Athletes Represented by {userDetails.first_name} {userDetails.last_name}</strong></span> */}
            <span class="view-user-profile-section-heading"><strong>Athletes Represented</strong></span>
        </div>
    </div>
    {toggles.AthleteRepToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="opinion-header profile_summary view-agent-profile-section-content">
                {Array.isArray(assignedAthletes) && assignedAthletes.length > 0 ? (
                <div className="agent-richtext-placeholder" style={{ border: "0", padding: "0" }}>
                    <span className='profile-applied-course-tag-row'>
                        {assignedAthletes.map((athlete, index) => {
                            return <span className='profile-applied-course-tags'><a href={"/view_athlete/"+athlete.id}>{athlete.name}</a></span>
                        })}  
                    </span>
                </div>
                ) : (
                <div
                    className="agent-richtext-placeholder empty"
                    style={{ border: "0" }}
                >
                    No athletes currently represented.
                </div>
                )}
            </div>
        </div>
    )}
</div>
</>}
{/* {sections.map((section) => {
    const content = backEndData?.[section.key]; //  dynamic backend binding

    return (
        <div
        key={section.keyToggle}
        className={`view-user-profile-section-header ${
            toggles[section.keyToggle] ? "open" : ""
        }`}
        >
            <div
                className="app-aspect-content"
                onClick={() => handleToggle(section.keyToggle)}
            >
                <div className="aspect-info">
                    <span className="view-user-profile-section-heading">
                        <strong>{section.title}</strong>
                    </span>
                </div>
            </div>

            {toggles[section.keyToggle] && (
                <div className="view-user-profile-section-body-container">
                    <div className="opinion-header profile_summary view-agent-profile-section-content">
                        
                        {content ? (
                            <div className="agent-richtext-placeholder" dangerouslySetInnerHTML={{ __html: content }} />
                        ) : (
                            <div className="agent-richtext-placeholder empty">
                                {section.emptyText}
                            </div>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
})} */}

</div>) : (<>
<EditAgentProfile uid={uid}  userLoggedInRoles={userLoggedInRoles} userAgentEditAssets={userAgentEditAssets} userSocialMediaAssets={userSocialMediaAssets} userDetails={userDetails} userCommonAssets={userCommonAssets} />
</>)}

</>
        )}
        </>
    );
};

export default ViewAgentProfile;